import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { LevelIndicator } from './LevelIndicator';
import { CaretIcon } from './CaretIcon';
import { FaEdit, FaLock } from 'react-icons/fa';
import { CustomFieldFormType } from '../TreeView';
export const TreeViewItem = ({ node, level, isField, sectionId, subsectionId, fieldId, isLast = false, onFieldChange, onSectionChange, onSubsectionChange, onEdit }) => {
    const isSectionExpanded = useMemo(() => (level === 1 && sectionId === node.id) || (level > 1 && subsectionId === node.id), [level, sectionId, subsectionId, node.id]);
    const isItemSelected = useMemo(() => fieldId === node.id, [fieldId, node.id]);
    const onItemClick = useCallback(() => {
        switch (level) {
            case CustomFieldFormType.Field:
                onFieldChange(node.id);
                //@ts-ignore
                node.isCustom && onEdit();
                break;
            case CustomFieldFormType.Section:
                onSectionChange(node.id);
                onEdit();
                break;
            case CustomFieldFormType.Subsection:
                onSubsectionChange(node.id);
                onEdit();
                break;
            default:
                return;
        }
        // if (isField) {
        // 	onFieldChange(node.id!);
        // 	//@ts-ignore
        // 	node.isCustom && onEdit()
        // } else {
        // 	level === 1 ? onSectionChange(node.id!) : onSubsectionChange(node.id!);
        // }
    }, [node.id, level, onFieldChange, onSectionChange, onSubsectionChange, onEdit]);
    return (_jsxs("div", Object.assign({ className: `field-style ${isSectionExpanded ? 'expanded' : ''} ${isItemSelected ? 'selected' : ''} d-flex align-items-star` }, { children: [_jsx(LevelIndicator, { level: level, isLast: isLast, isSectionExpanded: isSectionExpanded && level < 3 }), _jsxs("span", Object.assign({ className: 'ml-1', onClick: onItemClick }, { children: [level < 3 && !isField && _jsx(CaretIcon, { isExpanded: isSectionExpanded }), node.label] })), _jsx("span", Object.assign({ className: 'ml-auto px-2', onClick: onItemClick }, { children: ('isCustom' in node && node.isCustom) || level !== CustomFieldFormType.Field ? (_jsx(FaEdit, { color: 'rgba(0, 0, 0, 0.6)', size: '14', onClick: onEdit, style: { marginLeft: '8px', cursor: 'pointer' } })) : (_jsx(FaLock, { color: 'rgba(0, 0, 0, 0.6)', size: '14', style: { marginLeft: '8px' } })) }))] })));
};
